import { render, staticRenderFns } from "./ModifyEdit.vue?vue&type=template&id=1d61dd2e"
import script from "./ModifyEdit.vue?vue&type=script&lang=js"
export * from "./ModifyEdit.vue?vue&type=script&lang=js"
import style0 from "./ModifyEdit.vue?vue&type=style&index=0&id=1d61dd2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports